import * as React from 'react';
import { FC, ReactComponentElement } from 'react';
import { Header } from './Header';

type Props = {
  children: ReactComponentElement<any>;
};

/**
 * A functional component that wraps its children with a header.
 *
 * @param props - An object containing the following properties:
 *   - `children`: A React component element to be rendered within the section.
 *
 * @returns A React JSX element representing a section with a header and the provided children.
 */
export const WithHeader: FC<Props> = ({ children }: Props) => (
  <section>
    <Header />
    {children}
  </section>
);
